import VueRouter, { RawLocation } from "vue-router";
import { handleNavigationError } from "./errorHandler";

export const navigate = (router: VueRouter, location: RawLocation): Promise<void> =>
  // Vue Router 3 rejects push() when a guard redirects, even though the redirect succeeds.
  router.push(location).then(() => undefined).catch(handleNavigationError);
